/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pageCount: NonNullable<unknown>, maxPages: NonNullable<unknown> }} Conversion_Error_Too_Many_PagesInputs */

const en_conversion_error_too_many_pages = /** @type {(inputs: Conversion_Error_Too_Many_PagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This document has ${i?.pageCount} pages. The maximum is ${i?.maxPages} pages.`)
};

const es_conversion_error_too_many_pages = /** @type {(inputs: Conversion_Error_Too_Many_PagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este documento tiene ${i?.pageCount} páginas. El máximo es de ${i?.maxPages} páginas.`)
};

/**
* | output |
* | --- |
* | "This document has {pageCount} pages. The maximum is {maxPages} pages." |
*
* @param {Conversion_Error_Too_Many_PagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_too_many_pages = /** @type {((inputs: Conversion_Error_Too_Many_PagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Too_Many_PagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_too_many_pages(inputs)
	return en_conversion_error_too_many_pages(inputs)
});